// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__EeEck","container":"SectionFaq_container__7QqnT","faq__title":"SectionFaq_faq__title__2ZU4B","faq__list-container":"SectionFaq_faq__list-container__KM_Du"};